import React from 'react';
import { Phone, CheckCircle2, Star, Shield, ThumbsUp, Zap } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <div className="relative w-full bg-white" data-id="element-115">
      {/* Full-bleed background image sitting BEHIND the hero text */}
      <div className="absolute inset-0 z-0" data-id="element-116">
        <img src="https://images.unsplash.com/photo-1620626011761-996317b8d101?q=80&w=2000&auto=format&fit=crop" alt="Plumber repairing pipes under a residential kitchen sink" className="w-full h-full object-cover" data-id="element-117" />
        {/* Light scrim so the photo stays clearly visible while text remains legible */}
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-slate-900/40" data-id="element-118" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/40 via-transparent to-slate-900/80" data-id="element-119" />
      </div>

      <div className="relative z-10 container mx-auto px-4 pt-24 pb-20 md:pt-32 md:pb-28 flex flex-col items-start text-left" data-id="element-120">
        <div className="inline-flex items-center justify-center px-4 py-2 bg-accent/20 backdrop-blur-sm rounded-full mb-6 border border-accent/40 w-max" data-id="element-121">
          <span className="text-white font-bold tracking-widest uppercase text-sm" data-id="element-122">
            Serving Blanchard, OK & Surrounding Areas
          </span>
        </div>

        <h1 className="font-display text-4xl md:text-7xl lg:text-8xl uppercase tracking-wide mb-6 leading-[1.1] max-w-4xl" data-id="element-123">
          <span className="text-white" style={{
          textShadow: '0 0 18px rgba(13,27,48,0.95), 0 0 38px rgba(13,27,48,0.7), 0 2px 4px rgba(0,0,0,0.6)'
        }} data-id="element-124">
            Oklahoma's Trusted
          </span>{' '}
          <span className="text-accent-light" style={{
          textShadow: '0 0 18px rgba(255,255,255,0.95), 0 0 40px rgba(255,255,255,0.65), 0 2px 4px rgba(0,0,0,0.4)'
        }} data-id="element-125">
            Repairs
          </span>
        </h1>

        <p className="text-lg md:text-xl text-slate-200 max-w-2xl mb-10 font-medium drop-shadow" data-id="element-126">
          Expert plumbing, well pump, and home repair services. We deliver
          quality, honest work—from leaks to carpentry—with a focus on
          dependable service and lasting results.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto mb-8" data-id="element-127">
          <Button className="w-full sm:w-auto h-14 px-8 bg-accent hover:bg-accent-light text-white font-bold uppercase tracking-wider text-lg rounded-md" data-id="element-128">
            Book Service
          </Button>
          <Button variant="outline" className="w-full sm:w-auto h-14 px-8 border-2 border-white text-white hover:bg-white/10 font-bold uppercase tracking-wider text-lg rounded-md bg-transparent" data-id="element-129">
            <Phone className="mr-2 h-5 w-5" data-id="element-130" />
            (254) 266-9800
          </Button>
        </div>

        <div className="flex items-center gap-2 text-sm md:text-base text-slate-300 font-medium" data-id="element-131">
          <span data-id="element-132">Quality Work</span>
          <span className="text-accent-light" data-id="element-133">•</span>
          <span data-id="element-134">Honest Service</span>
          <span className="text-accent-light" data-id="element-135">•</span>
          <span data-id="element-136">Dependable</span>
        </div>
      </div>

      <div className="relative z-10 w-full bg-white border-y border-slate-200 py-6" data-id="element-137">
        <div className="container mx-auto px-4" data-id="element-138">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-139">
            <div className="flex flex-col items-center gap-2" data-id="element-140">
              <CheckCircle2 className="h-6 w-6 text-accent" data-id="element-141" />
              <span className="text-sm font-bold text-slate-700 uppercase tracking-wider" data-id="element-142">
                Home Improvements
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-143">
              <Star className="h-6 w-6 text-accent" data-id="element-144" />
              <span className="text-sm font-bold text-slate-700 uppercase tracking-wider" data-id="element-145">
                Plumbing
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-146">
              <Shield className="h-6 w-6 text-accent" data-id="element-147" />
              <span className="text-sm font-bold text-slate-700 uppercase tracking-wider" data-id="element-148">
                Well Pump Services
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-149">
              <ThumbsUp className="h-6 w-6 text-accent" data-id="element-150" />
              <span className="text-sm font-bold text-slate-700 uppercase tracking-wider" data-id="element-151">
                Free Estimates
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}